import React, {FC, HTMLAttributes, ReactNode} from 'react';
import classNames from 'classnames';
import style from './style.module.scss';

interface IProps extends HTMLAttributes<HTMLDivElement> {
    children?: ReactNode;
}

export const ShadowBlock: FC<IProps> = ({children, ...restDivAttributes}) => {
    return (
        <div {...restDivAttributes} className={classNames(restDivAttributes.className, style.shadowBlock)}>
            {children}
        </div>
    );
};
